import { render, staticRenderFns } from "./WaitingPeriodHeader.vue?vue&type=template&id=5686481a&scoped=true&"
import script from "./WaitingPeriodHeader.vue?vue&type=script&lang=js&"
export * from "./WaitingPeriodHeader.vue?vue&type=script&lang=js&"
import style0 from "./WaitingPeriodHeader.vue?vue&type=style&index=0&id=5686481a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686481a",
  null
  
)

export default component.exports